<template>
  <table class="striped client-notes">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th class="client-note-date">Date</th>
        <th class="client-note-author">User</th>
        <th class="client-note-message">Notes</th>
        <th class="client-note-remove"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(note, index) in paginatedNotes" :key="index">
        <td class="client-note-date">{{ formatTimestamp(note.createdAt) }}</td>
        <td class="client-note-author">
          {{ getUserName(note.author) }}
        </td>
        <td
          class="client-note-message-text"
          v-html="formatHTML(note.message)"
          v-if="note.id"
        ></td>
        <td class="client-note-message-input" v-if="!note.id">
          <textarea
            :id="`client-note-${index}-message`"
            placeholder="add note here..."
            required
            v-model.trim="note.message"
          />
        </td>
        <td class="client-note-remove" v-if="!note.id">
          <icon-button
            :id="`client-note-${index}-remove`"
            name="remove"
            @click="handleRemove(note)"
            v-if="canRemove && note.id === undefined"
          />
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="page-controls" colspan="4">
          <icon-button
            :disabled="disabled"
            id="client-notes-add"
            name="add"
            @click="handleAdd"
            v-if="canAdd"
          />

          <icon-button
            :disabled="!hasPrevPage"
            id="client-notes-page-prev"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            id="client-notes-page-next"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("notes")],

  props: {
    canAdd: {
      type: Boolean,
      default: true,
    },
    canRemove: {
      type: Boolean,
      default: true,
    },
    caption: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    notes: {
      type: Array,
    },
  },

  methods: {
    handleAdd() {
      this.canAdd &&
        this.$emit("update:notes", [
          {
            author: {
              ...this.$store.getters.user,
              permissions: undefined,
              roles: undefined,
            },
            createdAt: new Date().toJSON(),
          },
          ...this.notes,
        ]);
    },
    handleRemove(note) {
      this.canRemove &&
        this.$emit(
          "update:notes",
          this.notes.filter((n) => n !== note)
        );
    },
  },
};
</script>

<style>
.client-notes {
  border-collapse: collapse;
  display: grid;
  grid-template-columns: 6em 12em 1fr 2em;
  margin: 0;
  padding: 0;
  width: 100%;
}

.client-notes tbody,
.client-notes thead,
.client-notes tfoot,
.client-notes tr {
  display: contents;
}

.client-notes button {
  height: 2em;
  vertical-align: top;
  width: 2em;
}

.client-notes thead th {
  background: var(--primary-red);
  color: var(--primary-white);
  text-align: left;
  text-transform: uppercase;
}

.client-notes thead th,
.client-notes tbody td {
  margin: 0;
  padding: 0.2em 0.2em;
}

.client-notes tbody td {
  vertical-align: top;
}

.client-notes tbody td.client-note-date,
.client-notes tbody td.client-note-author {
  color: var(--primary-red);
}

.client-notes tbody td.client-note-message-text {
  grid-column: span 2;
  max-height: 6em;
  overflow: auto;
}

.client-notes tbody td.client-note-message-input textarea {
  background: transparent;
  border: none;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  height: 100%;
  resize: vertical;
  width: 100%;
}

.client-notes
  tbody
  td.client-note-message-input
  textarea::-webkit-input-placeholder {
  color: var(--primary-medium-gray);
  opacity: 1;
}

.client-notes tbody td.client-note-message-input textarea::placeholder {
  color: var(--primary-medium-gray);
  opacity: 1;
}

.client-notes tbody tr:nth-child(2n + 1) td {
  background: var(--primary-light-gray);
}

.client-notes tbody td button {
  height: 1.33em;
  width: 1.33em;
}

.client-notes tbody td button > i {
  font-size: 0.4em;
}

.client-notes tfoot td {
  grid-column: span 4;
  padding-top: 0.4em;
}

.client-notes .client-note-date {
  width: 6em;
}

.client-notes .client-note-author {
  width: 12em;
}

.client-notes .client-note-remove {
  text-align: right;
  width: 2em;
}
</style>